import React, { useEffect, useState } from "react";
import PageBanner from "../Components/PageBanner";
import { HiMail } from "react-icons/hi";
import { FiPhoneCall } from "react-icons/fi";
import { MdPhone } from "react-icons/md";
import axios from "axios";
import { Link } from "react-router-dom";
import contacto from "../assets/contact.jpg";
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "react-toastify";
import { AiFillChrome, AiOutlineClockCircle } from "react-icons/ai";
import { FaWhatsapp } from "react-icons/fa";

import Navbar from "../Components/Navbar";

const Contact = ({ }) => {
  const [cred, setCred] = useState({
    email: "",
    phone: "",
    message: ""
  });
  const [robot, setRobot] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const ScrollToTop = () => {
      window.scrollTo(0, 0);
    };
    ScrollToTop();
  }, []);

  function onChange(value) {
    setRobot(value);
  }

  const HandleSubmit = async (e) => {
    e.preventDefault();
    if (
      cred.email.length > 0 &&
      cred.phone.length > 0 &&
      cred.message.length > 0 &&
      robot
    ) {
      setLoading(true);
      if (document.getElementById("flexCheckDefault").checked) {
        await axios.post(process.env.REACT_APP_BASE_URL + "/api/auth/contact", {
          ...cred,
        });
        toast.success(<span className="small text-dark">¡MENSAJE ENVIADO!</span>, {
          type: "success",
        });
        document.getElementById("flexCheckDefault").checked = false;
        setCred({ phone: "", email: "", message: "" });
        setLoading(false);
      } else {
        toast.error(
          <span className="small">Acepta nuestros Términos y Condiciones</span>,
          {
            type: "error",
          }
        );
        setLoading(false);
      }
    } else {
      toast.error(<span className="small">Completar todos los datos!</span>, {
        type: "error",
      });
    }
  };

  const HandleChange = (e) => {
    setCred((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  return (
    <div className="contact bg-white column-resp">
      <Navbar />
      <div className="canvas col_resp pb-4">
        <h1 className="fw-bold mt-5 p-3 text-center">Atención al Cliente</h1>
        <form
          className="d-flex justify-content-between mt-4 col_resp"
          onSubmit={HandleSubmit}
        >
          <div className="register_1">
            <div className="d-flex w-100">
              <div className="d-flex align-items-center justify-content-center icon me-3">
                <HiMail size={40} color="white" />
              </div>
              <div>
                <h3 className="fw-bold">Email</h3>
                <p className="font2 mt-2">info.es@transferven.com</p>
              </div>
            </div>
            <div className="d-flex w-100 mt-4">
              <div
                className="d-flex align-items-center justify-content-center
           icon me-3"
              >
                <FiPhoneCall size={37} color="white" />
              </div>
              <div>
                <h3 className="fw-bold">Call Center</h3>
                <div className="mt-2 d-flex align-items-center">
                  <MdPhone size={20} color="#fc364e" />
                  <p className="font2 ms-3 mb-0">+34 91 993 13 12</p>
                </div>
                <div
                  className="mt-2 d-flex align-items-center"
                  onClick={() => window.open("https://wa.me/34620818181", "_blank")}
                  style={{ cursor: "pointer" }}
                >
                  <FaWhatsapp size={20} color="#25D366" />
                  <p className="font2 ms-3 mb-0">+34 620 81 81 81</p>
                </div>

                {/* <div className="mt-2 d-flex align-items-center">
                  <MdPhone size={20} color="#fc364e" />
                  <p className="font2 ms-3 mb-0">+58 424 349 3861</p>
                </div> */}
                {/* <p className="font2 mt-1">+34 611 54 55 95</p> */}
                <div className="mt-2 d-flex align-items-center">
                  <AiOutlineClockCircle size={20} color="#fc364e" />
                  <p className="ms-3 font2">L a V de 10 a 18 Hrs.</p>
                </div>
                <div className="mt-2 d-flex align-items-center">
                  <AiFillChrome size={20} color="#fc364e" style={{ visibility: "hidden" }} />
                  <p className="ms-3 font2">Web 24 Hrs.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="register_2">
            <label>Nombre</label>
            <input
              type={"text"}
              className="rounded-0 form-control mt-2"
              onChange={(e) => HandleChange(e)}
              id="phone"
              value={cred.phone}
            />
            <label className="mt-1">Email</label>
            <input
              type={"email"}
              className="rounded-0 form-control mt-1"
              onChange={(e) => HandleChange(e)}
              id="email"
              value={cred.email}
            />
            <label className="mt-2">Mensaje</label>
            <textarea
              className="form-control mt-1 rounded-0"
              placeholder="Escribe tu mensaje"
              onChange={(e) => HandleChange(e)}
              id="message"
              value={cred.message}
            />

            <div className="d-flex align-items-start form-check mt-3">
              <input
                className="form-check-input mb-0"
                style={{ width: "25px", height: "25px" }}
                type="checkbox"
                id="flexCheckDefault"
              />
              <label
                className="form-check-label text-muted ms-2"
                htmlFor="flexCheckDefault"
                style={{ width: "calc(100% - 35px)" }}
              >
                Haciendo click aquí, aceptas nuestros{" "}
                <Link to="/terms" target="_blank">
                  Términos y Condiciones
                </Link>{" "}
                y
                <Link to={"/protection"} target="_blank">
                  {" "}
                  Política general en materia de Protección de Datos
                </Link>{" "}
                de Transferven y nos autorizas a contactarte por E-mail, SMS y
                Whatsapp.
              </label>
            </div>

            <ReCAPTCHA
              sitekey="6Ld2YggpAAAAACwfxHxBPm1_LxtxDO17jtULGO3T"
              onChange={onChange}
              onExpired={(e) => e.reset()}
              className="mt-3"
            />

            <p className="text-danger">{!robot && "Verify Recaptcha!"}</p>

            <button
              className="continue w-auto px-4"
              disabled={loading}
            >
              {loading ? "Enviando" : "Enviar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default (Contact);
